var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOutOfStockProducts(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6593",
    "data-name": "Group 6593",
    transform: "translate(-1061 -416)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_329",
    "data-name": "Ellipse 329",
    cx: 52,
    cy: 52,
    r: 52,
    transform: "translate(1061 416)",
    fill: "#ffdbdb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g579",
    transform: "translate(1087.647 1125.312)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g581",
    transform: "translate(1.354 -681.311)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6592",
    "data-name": "Group 6592",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g589"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path591",
    d: "M-580.333-245.9v-10.381a10.381,10.381,0,0,0-10.381-10.381h-28.236a10.381,10.381,0,0,0-10.381,10.381v28.236a10.381,10.381,0,0,0,10.381,10.381h10.8",
    transform: "translate(629.332 266.666)",
    fill: "none",
    stroke: "red",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g593",
    transform: "translate(19.205 9.343)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path595",
    d: "M0,0H10.589",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "red",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g597",
    transform: "translate(25.122 25.122)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path599",
    d: "M-282.789-141.395a11.938,11.938,0,0,1-11.938,11.938,11.938,11.938,0,0,1-11.938-11.938,11.938,11.938,0,0,1,11.938-11.938A11.938,11.938,0,0,1-282.789-141.395Z",
    transform: "translate(306.666 153.333)",
    fill: "none",
    stroke: "red",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g601",
    transform: "translate(40.663 33.458) rotate(45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path603",
    d: "M0,10.189V0",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "red",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g605",
    transform: "translate(33.458 33.458) rotate(45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path607",
    d: "M10.189,0H0",
    fill: "none",
    stroke: "red",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutOfStockProducts);
export default __webpack_public_path__ + "static/media/out-of-stock-products.bda35e867b2ebb20c8e0de87fe524739.svg";
export { ForwardRef as ReactComponent };